{
    "UserMenu_Notifications": "Meldingen",
    "UserMenu_UserTour": "Start gebruikerseducatietour",
    "UserMenu_ShowInsights": "Dashboard met inzichten weergeven",
    "UserMenu_HideInsights": "Verberg Insights Dashboard",
    "UserMenu_ChangePassword": "Wachtwoord wijzigen",
    "UserMenu_ChangeLanguage": "Taal wijzigen",
    "UserMenu_Timezone": "Tijdzone wijzigen",
    "UserMenu_Help": "Hulp",
    "UserMenu_ClearContentful": "Cache van inhoud wissen",
    "UserMenu_ChangeBrowserProfile": "Browserprofiel wijzigen",
    "UserMenu_Resources": "Bronnen",
    "UserMenu_Resources_Terms": "Algemene voorwaarden",
    "UserMenu_Resources_CookiePolicy": "Cookiebeleid",
    "UserMenu_Resources_PrivacyPolicy": "Privacybeleid",
    "UserMenu_Logout": "Uitloggen",
    "NAME": "UserMenu"
}